<template>
  <section>
    <div class="card">
      <div class="card-header">
        <h4>Logout</h4>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-12">
            <v-button
              @click.native="logoutUsers()"
              :working="loggingOut"
              class="btn btn-warning"
              >Alle User ausloggen</v-button
            >
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="babel">
export default {
  data() {
    return {
      loggingOut: false
    };
  },
  methods: {
    logoutUsers() {
      if (this.loggingOut) {
        return;
      }

      this.loggingOut = true;
      this.$http
        .post("/api/v1/userLogout/")
        .then(() => {
          this.$notify({
            title: `Alle User wurden ausgeloggt`,
            type: "success"
          });
        })
        .finally(() => {
          this.loggingOut = false;
        });
    }
  }
};
</script>
